import { render } from "./BackToSiteButton.vue?vue&type=template&id=55851c3a&scoped=true"
import script from "./BackToSiteButton.vue?vue&type=script&lang=js"
export * from "./BackToSiteButton.vue?vue&type=script&lang=js"

import "./BackToSiteButton.vue?vue&type=style&index=0&id=55851c3a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55851c3a"]])

export default __exports__